/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ic_arc': {
    width: 269,
    height: 403,
    viewBox: '0 0 269 403',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M269 134.5C269 60.218 208.782 0 134.5 0v134.5H269z" _fill="#9FB4FE"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M0 134.5C0 60.218 60.218 0 134.5 0v134.5H0z" _fill="#5F01D3"/><path pid="2" fill-rule="evenodd" clip-rule="evenodd" d="M269 268.5c0-74.282-60.218-134.5-134.5-134.5v134.5H269z" _fill="#FFBFAB"/>'
  }
})
